import { Star, ShieldCheck, BadgeCheck, Loader2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const REDIRECT = () => window.location.origin + "/dashboard";
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const googleLogin = () => {
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(REDIRECT())}`;
};

export function Stars({ value = 0, size = 14 }) {
  return (
    <span className="inline-flex items-center gap-0.5" title={`${value}/5`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} size={size}
          className={i <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-navy-300"} />
      ))}
    </span>
  );
}

export function VerifiedBadge({ verified }) {
  if (!verified)
    return <Badge variant="outline" className="border-navy-300 text-navy-500 gap-1"><ShieldCheck size={12} /> Unverified</Badge>;
  return (
    <Badge className="bg-emerald-500 hover:bg-emerald-500 text-white gap-1" data-testid="verified-badge">
      <BadgeCheck size={12} /> Verified
    </Badge>
  );
}

const STATUS_COLORS = {
  OPEN: "bg-sky-100 text-sky-700", QUOTED: "bg-amber-100 text-amber-700",
  CONTRACTED: "bg-emerald-100 text-emerald-700", CLOSED: "bg-navy-100 text-navy-600",
  ACTIVE: "bg-emerald-100 text-emerald-700", PENDING_ACCEPTANCE: "bg-amber-100 text-amber-700",
  COMPLETED: "bg-navy-100 text-navy-600", TERMINATED: "bg-red-100 text-red-700",
  PENDING: "bg-amber-100 text-amber-700", PAID: "bg-emerald-100 text-emerald-700",
  OVERDUE: "bg-red-100 text-red-700", SUBMITTED: "bg-sky-100 text-sky-700",
  ACCEPTED: "bg-emerald-100 text-emerald-700", REJECTED: "bg-red-100 text-red-700",
  VERIFIED: "bg-emerald-100 text-emerald-700", UNDER_REVIEW: "bg-amber-100 text-amber-700",
  EXPIRED: "bg-red-100 text-red-700", DISPATCHING: "bg-brand-100 text-brand-600",
  ON_LEAVE: "bg-amber-100 text-amber-700", ABSENT: "bg-red-100 text-red-700",
  REPLACEMENT_REQUIRED: "bg-red-100 text-red-700", INACTIVE: "bg-navy-100 text-navy-600",
  VALID: "bg-emerald-100 text-emerald-700", LATE: "bg-amber-100 text-amber-700",
  PRESENT: "bg-emerald-100 text-emerald-700", LEAVE: "bg-sky-100 text-sky-700",
  OVERTIME: "bg-violet-100 text-violet-700",
};

export function StatusPill({ status }) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${STATUS_COLORS[status] || "bg-navy-100 text-navy-600"}`}>
      {String(status || "").replace(/_/g, " ")}
    </span>
  );
}

export function LoadingScreen({ label = "Loading…" }) {
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center text-navy-500">
      <Loader2 className="w-8 h-8 animate-spin text-brand" />
      <p className="mt-3">{label}</p>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, hint, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center border border-dashed border-navy-200 rounded-xl bg-white">
      {Icon && <Icon className="w-10 h-10 text-navy-300" />}
      <p className="mt-3 font-heading text-lg font-semibold text-navy-800">{title}</p>
      {hint && <p className="text-navy-500 text-sm mt-1 max-w-md">{hint}</p>}
      {action}
    </div>
  );
}

export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");
